import { action, observable } from 'mobx';
import { TaskCommentForm } from 'application/schedule/forms';
import { BaseEditViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { TaskCommentService } from 'application/schedule/services';
import { TaskCommentNotificationService } from 'application/dashboard/services';
import _ from 'lodash';

@applicationContext
class TaskCommentStore extends BaseEditViewStore {
    @observable accessor comments = [];

    constructor(rootStore, componentProps) {
        const service = new TaskCommentService(rootStore.application.baasic.apiClient);
        const taskCommentNotificationService = new TaskCommentNotificationService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'task-comment',
            Form: TaskCommentForm,
            actions: () => {
                return {
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    },
                    find: async (params) => {
                        const response = await service.find(params);
                        return response.data;
                    },
                }
            },
            FormClass: TaskCommentForm,
        });

        this.service = service;
        this.props = componentProps;
        this.userId = rootStore.userStore.user.id;
        this.taskCommentNotificationService = taskCommentNotificationService;

        this.findResource();

        this.form.set({
            facilityScheduleDateId: this.props.facilityScheduleDateId,
            authorId: rootStore.userStore.user.id
        })
    }

    @action.bound
    async findResource() {
        if (!this.actions.find || this.props.facilityScheduleDateId == null) return;
        let filter = {
            facilityScheduleDateId: this.props.facilityScheduleDateId,
            embed: "Author,TaskCommentNotifications",
            sort: "dateUpdated|desc",
            rpp:"100"
        }
        const response = await this.actions.find(filter);
        const taskComments = _.map(response.item, (item) => {
            const unReadLoggedInUser = item.taskCommentNotifications.find(p=>p.person.userId === this.userId && p.isRead === false);
            return _.extend(item, {
                unRead: unReadLoggedInUser != null
            }); 
        });
        let unReadMessages = _.map(response.item, (item) => {
            return item.taskCommentNotifications.filter(p=>p.person.userId === this.userId && p.isRead === false).map(t=>{
                t.isRead = true;
                t.person = null;
                return t;
            });
        });
        this.setData(taskComments);
        this.updateTaskCommentNotification(unReadMessages.flat().filter(Boolean));
    }
    @action.bound
    async updateTaskCommentNotification(resource) {
        if(resource == null || resource.length == 0){return}
        try {
            await this.taskCommentNotificationService.batchUpdate(resource);

            const masterView = this.rootStore.masterView != null ? this.rootStore.masterView: this.rootStore.masterView_0;
            await masterView.globalTaskNotificationsStore.countNotifications();
        }
        catch(err) {
            return this.onUpdateError(err);
        }
    }

    @action.bound
    setData(data, mapper = (i) => i) {
        let items = data.item ? data.item : data;
        items = _.map(items, mapper);
        this.comments = items;
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(resource);

            this.form.$('message').clear();

            this.form.setFieldsDisabled(false);
            this.findResource();
            await setTimeout(() => this.notifySuccessCreate(), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onCreateError(err);
        }
    }
}

export default TaskCommentStore;
